import React, { HTMLAttributes } from "react";
import classNames from "classnames";

export type CardProps = HTMLAttributes<HTMLElement> & {
   [key: string]: any;
   tag?: React.ElementType;
   className?: string,
   selected?: boolean,
   active?: boolean,
}

export const Card: React.FC<CardProps> = React.forwardRef<HTMLElement, CardProps>(({ tag = "div", className, selected = false, active = false, ...rest }, ref) => {
   const mergedClassNames = classNames("card",
      { "card--selected": selected },
      { "card--active": !selected && active },
      className);
   return React.createElement(tag, { ref: ref, className: mergedClassNames, ...rest });
});